/*
 * ktechs attach rail — drawer add-on row behaviors.
 * The rail itself is server-rendered (snippets/ktechs-cart-rail.liquid) and
 * re-renders whenever the theme swaps the cart-drawer section. This file only
 * adds: quantity-aware adds (the theme's quick-add hardcodes qty 1), Add-all,
 * per-visit rotation, and the stagger-in choreography.
 */
(function () {
  'use strict';

  var ROT_KEY = 'ktechs-rail-rot';
  var SECTIONS = ['cart-drawer', 'cart-bubble'];
  var SWAPS = [
    { id: 'Cart-Drawer', section: 'cart-drawer', selector: '.cart-drawer' },
    { id: 'cart-drawer-toggle', section: 'cart-bubble', selector: '.thb-item-count' },
    { id: 'Cart', section: 'main-cart', selector: '.thb-cart-form' }
  ];

  function readRot() {
    try { return JSON.parse(localStorage.getItem(ROT_KEY) || '{}'); } catch (e) { return {}; }
  }
  function writeRot(state) {
    try { localStorage.setItem(ROT_KEY, JSON.stringify(state)); } catch (e) { /* private mode */ }
  }

  /* Rotation: each rotating slot rendered up to 6 candidates; show the one
     after the last-shown, hide the rest. Cycles the pool, no back-to-back
     repeats per browser; a card in "added" state always wins visibility. */
  function rotate(root) {
    var cards = root.querySelectorAll('[data-rail-rotate]');
    if (!cards.length) return;
    var groups = {};
    cards.forEach(function (card) {
      var g = card.getAttribute('data-rail-rotate');
      (groups[g] = groups[g] || []).push(card);
    });
    var state = readRot();
    Object.keys(groups).forEach(function (g) {
      var list = groups[g];
      if (list.length === 1) { list[0].hidden = false; return; }
      var added = list.filter(function (c) { return c.classList.contains('ktechs-rail-card--added'); });
      var pick;
      if (added.length) {
        pick = added[0];
      } else {
        var last = String(state[g] || '');
        var idx = list.findIndex(function (c) { return c.getAttribute('data-rail-product') === last; });
        pick = list[(idx + 1) % list.length];
        state[g] = pick.getAttribute('data-rail-product');
      }
      list.forEach(function (c) { c.hidden = c !== pick; });
    });
    writeRot(state);
  }

  function stagger(root) {
    var rail = root.querySelector('ktechs-cart-rail');
    if (!rail || rail.classList.contains('ktechs-rail--stagger')) return;
    var i = 0;
    rail.querySelectorAll('.ktechs-rail-card').forEach(function (card) {
      if (card.hidden) return;
      card.style.setProperty('--rail-i', i++);
    });
    rail.classList.add('ktechs-rail--stagger');
  }

  function initRail() {
    /* rotation groups live in the drawer AND on the page (gems teaser) */
    rotate(document.body);
    var drawer = document.getElementById('Cart-Drawer');
    if (drawer) stagger(drawer);
    sync();
  }

  function swapSections(sections) {
    SWAPS.forEach(function (swap) {
      if (!sections[swap.section]) return;
      var host = document.getElementById(swap.id);
      if (!host) return;
      var target = host.querySelector(swap.selector) || host;
      var doc = new DOMParser().parseFromString(sections[swap.section], 'text/html');
      var next = doc.querySelector(swap.selector);
      if (next) target.innerHTML = next.innerHTML;
    });
    initRail();
    var drawer = document.getElementById('Cart-Drawer');
    /* open only if currently closed — re-opening an open drawer jolts it */
    if (drawer && drawer.hasAttribute('inert')) {
      if (typeof OverlayManager !== 'undefined') OverlayManager.open(drawer);
      if (typeof dispatchCustomEvent === 'function') dispatchCustomEvent('cart-drawer:open');
    }
  }

  function addItems(items, button) {
    if (button.classList.contains('loading')) return;
    button.classList.add('loading');
    button.setAttribute('aria-disabled', 'true');
    fetch((window.theme && theme.routes && theme.routes.cart_add_url || '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        items: items,
        sections: SECTIONS.concat('main-cart').join(','),
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status && !data.items) {
          /* hard failure — nothing was added */
          console.error('[ktechs-rail]', data.description || data.message);
          return;
        }
        if (data.status) {
          /* partial add (availability clamp) — show reality, don't bail */
          console.warn('[ktechs-rail]', data.description || data.message);
        }
        if (data.sections) {
          swapSections(data.sections);
        } else {
          /* soft-error responses can omit sections — fetch them once */
          fetch(window.location.pathname + '?sections=' + SECTIONS.join(','))
            .then(function (r) { return r.ok ? r.json() : null; })
            .then(function (sections) { if (sections) swapSections(sections); })
            .catch(function () { /* leave drawer as-is */ });
        }
        if (typeof dispatchCustomEvent === 'function') {
          dispatchCustomEvent('cart:item-added', { product: data.items ? data.items[0] : data });
        }
      })
      .catch(function (e) { console.error('[ktechs-rail]', e); })
      .finally(function () {
        button.classList.remove('loading');
        button.removeAttribute('aria-disabled');
      });
  }



  function postCart(path, body, button) {
    if (button && button.classList.contains('loading')) return Promise.resolve();
    if (button) button.classList.add('loading');
    body.sections = SECTIONS.concat('main-cart').join(',');
    body.sections_url = window.location.pathname;
    return fetch(path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) { console.warn('[ktechs-cart]', data.description || data.message); return; }
        if (data.sections) swapSections(data.sections);
      })
      .catch(function (e) { console.error('[ktechs-cart]', e); })
      .finally(function () { if (button) button.classList.remove('loading'); });
  }

  /* assembly folded under a keyboard row: tick adds a line FOR that keyboard,
     untick removes exactly that line (spec §15.2) */
  document.addEventListener('change', function (e) {
    if (!e.target || e.target.type !== 'checkbox') return;
    var row = e.target.closest('[data-line-assembly]');
    if (!row) return;
    if (e.target.checked) {
      var props = {};
      props[row.getAttribute('data-for-label') || 'For'] = row.getAttribute('data-for-title') || '';
      props._ktechs_for = row.getAttribute('data-for-variant');
      addItems([{ id: Number(row.getAttribute('data-assembly-variant')), quantity: Number(row.getAttribute('data-for-qty')) || 1, properties: props }], row);
    } else {
      var key = row.getAttribute('data-assembly-key');
      if (key) postCart('/cart/change.js', { id: key, quantity: 0 }, row);
    }
  });

  /* removing a keyboard removes its folded assembly in the same request (§15.3) */
  document.addEventListener('click', function (e) {
    var remove = e.target.closest('cart-remove');
    if (!remove) return;
    var host = remove.closest('.product-cart-item') || remove.closest('tr');
    var row = host && host.querySelector('[data-line-assembly]');
    var asmKey = row && row.getAttribute('data-assembly-key');
    if (!asmKey) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var updates = {};
    updates[row.getAttribute('data-for-key')] = 0;
    updates[asmKey] = 0;
    postCart('/cart/update.js', { updates: updates }, row);
  }, true);

  /* render-time sweep: quantity follows the keyboard, orphans go, bare lines
     attach to the first keyboard without assembly or go (§15.3, §15.4) */
  var syncStamp = 0;
  function sync() {
    var node = document.querySelector('[data-ktechs-cart-sync]:not([data-done])');
    if (!node) return;
    node.setAttribute('data-done', '1');
    var now = Date.now();
    if (now - syncStamp < 4000) return; /* never loop on a cart Shopify keeps clamping */
    syncStamp = now;
    var data;
    try { data = JSON.parse(node.textContent); } catch (err) { return; }
    var updates = {};
    (data.updates || '').split(',').filter(Boolean).forEach(function (pair) {
      var i = pair.lastIndexOf(':');
      updates[pair.slice(0, i)] = Number(pair.slice(i + 1));
    });
    var bare = (data.bare || '').split(',').filter(Boolean);
    var chain = Promise.resolve();
    if (bare.length) {
      if (data.adopt) {
        var anyRow = document.querySelector('[data-line-assembly]');
        var props = {};
        props[anyRow ? anyRow.getAttribute('data-for-label') : 'For'] = data.adopt.title;
        props._ktechs_for = String(data.adopt.variant);
        chain = chain.then(function () { return postCart('/cart/change.js', { id: bare[0], quantity: Number(data.adopt.qty) || 1, properties: props }); });
        bare.slice(1).forEach(function (key) { updates[key] = 0; });
      } else {
        bare.forEach(function (key) { updates[key] = 0; });
      }
    }
    if (Object.keys(updates).length) {
      chain = chain.then(function () { return postCart('/cart/update.js', { updates: updates }); });
    }
  }

  document.addEventListener('click', function (e) {
    var one = e.target.closest('[data-rail-add]');
    if (one) {
      e.preventDefault();
      addItems([{ id: Number(one.getAttribute('data-variant-id')), quantity: Number(one.getAttribute('data-qty')) || 1 }], one);
      return;
    }
    var all = e.target.closest('[data-rail-add-all]');
    if (all) {
      e.preventDefault();
      var items = (all.getAttribute('data-items') || '')
        .split(',')
        .filter(Boolean)
        .map(function (pair) {
          var bits = pair.split(':');
          return { id: Number(bits[0]), quantity: Number(bits[1]) || 1 };
        });
      if (items.length) addItems(items, all);
    }
  });

  document.addEventListener('cart-drawer:open', initRail);

  /* Quantity changes and removals re-render the drawer without the open
     event — watch for the rail node being replaced. */
  var host = document.getElementById('Cart-Drawer');
  if (host && 'MutationObserver' in window) {
    new MutationObserver(function () { initRail(); }).observe(host, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initRail);
  } else {
    initRail();
  }
})();
